import { useState, useContext } from "react";
import { Typography } from "@mui/material";
import { toast } from "react-toastify";

import MUISelect from "./../../../Component/UI/MUISelect/MUISelect";
import MUIChip from "../../../Component/UI/MUIChip/MUIChip";
import { DiscoveryContext } from "../../Discovery/discovery-context";
import Modal from "../../../Component/Modal/Modal";
import TextInput from "../../../Component/UI/TextInput/TextInput";
import classes from "./AttributeInput.module.css";

export default function AttributeInput({ label, disabled, prefLoading }) {
  const [showAddManualDialog, setShowAddManualDialog] = useState(false);
  const [userEnteredAttribute, setUserEnteredAttribute] = useState("");

  const discoveryCtx = useContext(DiscoveryContext);

  const onPrefSelect = (event) => {
    if (discoveryCtx.attributes.length === 3) {
      toast.warn("Max 3 attributes allowed");
      return;
    }
    discoveryCtx.updateAttribute([
      ...discoveryCtx.attributes,
      event.target.value,
    ]);
  };

  const handleDelete = (chipToDelete) => () => {
    discoveryCtx.updateAttribute(
      discoveryCtx.attributes.filter((chip) => chip !== chipToDelete)
    );
  };

  const selectOptions = [
    ...discoveryCtx.product_prefs.map((pref) => ({
      id: pref,
      name: pref,
      value: pref,
    })),
    { id: 0, name: "Add Manually", value: "Add Manually" },
  ];

  return (
    <div className="d-flex flex-column">
      <MUISelect
        loading={prefLoading}
        optionValue={""}
        label={label}
        options={selectOptions}
        disabled={disabled}
        onChange={(e) => {
          if (e.target.value === "Add Manually") {
            if (discoveryCtx.category.trim().length === 0) {
              toast.warn("Please enter product category first");
              return;
            }
            setShowAddManualDialog(true);
            return;
          }
          onPrefSelect(e);
        }}
      ></MUISelect>
      {discoveryCtx.attributes.length === 0 && (
        <Typography
          color="textDisabled"
          variant="caption"
          sx={{ fontSize: "8px" }}
        >
          Choose upto 3 attributes
        </Typography>
      )}
      <div className="d-flex mt-2">
        {discoveryCtx.attributes.map((value) => (
          <MUIChip
            disabled={discoveryCtx.loading || discoveryCtx.is_launched}
            key={value}
            label={value}
            size="small"
            onDelete={handleDelete(value)}
            sx={{ marginRight: 0.5 }}
          />
        ))}
      </div>
      {showAddManualDialog && (
        <Modal
          title="Add Attribute"
          open={showAddManualDialog}
          showActions
          handleClose={() => setShowAddManualDialog(false)}
          confirmBtnDisabled={!userEnteredAttribute}
          handleConfirm={() => {
            setShowAddManualDialog(false);
            onPrefSelect({ target: { value: userEnteredAttribute } });
          }}
        >
          <TextInput
            className={classes.input}
            fullWidth
            type="text"
            onChange={(e) => setUserEnteredAttribute(e.target.value)}
            placeholder="Enter attribute name"
          />
        </Modal>
      )}
    </div>
  );
}
